// src/Components/System/ServerError.js
import React from 'react';
import noNet from '../../assets/images/noNet.jpg'
import {RiSignalWifiErrorLine} from "react-icons/ri";
import {IoReloadSharp} from "react-icons/io5";
const ServerError = () => {
    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }
    return (
        <section className="container mobile-size-option">
            <div className="row">
                <div className='text-center mt-5 p-3 col-12'>
                    <RiSignalWifiErrorLine className=' mb-3 text-big-3em'/>
                    <h1 className='text-dark mb-4'>خطا در اتصال به سرور</h1>
                    <p className='text-secondary'>لطفاً اتصال اینترنت خود را بررسی کنید یا بعداً تلاش کنید.</p>

                    <img src={noNet} alt="No Net" className='w-100'/>

                </div>
                <div className='col-12'>
                    <button className='btn btn-outline-dark w-100 mt-3' onClick={() => {
                        window.location.reload()
                    }}>
                        <IoReloadSharp className='mx-2 text-big-2' />
                        تلاش مجدد
                    </button>
                    <button className='btn  btn-outline-danger w-100 mt-4' onClick={onExitClick}>

                        پاک کردن داده و ورود مجدد
                    </button>
                </div>
            </div>

        </section>

    );
};

export default ServerError;
